var _rect, _path, _circle, _circle2, _line;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFuelTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 64,
    viewBox: "0 0 211 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.4888,
    y: 16.9712,
    width: 190.011,
    height: 35.5288,
    fill: "#2A484D",
    stroke: "#FFF9B5",
    strokeDasharray: "200 200"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0185 45.188V25.028H110.499V28.052H95.0705V33.596H107.475V36.62H95.0705V45.188H92.0185ZM115.753 45.188C115.081 45.188 114.465 45.02 113.905 44.684C113.364 44.348 112.925 43.9093 112.589 43.368C112.272 42.8267 112.113 42.22 112.113 41.548V28.948H115.137V41.464C115.137 41.6507 115.202 41.8187 115.333 41.968C115.482 42.0987 115.65 42.164 115.837 42.164H124.909C125.096 42.164 125.254 42.0987 125.385 41.968C125.534 41.8187 125.609 41.6507 125.609 41.464V28.948H128.633V41.548C128.633 42.22 128.465 42.8267 128.129 43.368C127.812 43.9093 127.373 44.348 126.813 44.684C126.272 45.02 125.665 45.188 124.993 45.188H115.753ZM134.646 45.188C133.974 45.188 133.367 45.02 132.826 44.684C132.285 44.348 131.846 43.9093 131.51 43.368C131.174 42.8267 131.006 42.22 131.006 41.548V32.588C131.006 31.916 131.174 31.3093 131.51 30.768C131.846 30.2267 132.285 29.788 132.826 29.452C133.367 29.116 133.974 28.948 134.646 28.948H143.886C144.558 28.948 145.165 29.116 145.706 29.452C146.266 29.7693 146.705 30.208 147.022 30.768C147.358 31.328 147.526 31.9347 147.526 32.588V38.58H134.03V41.464C134.03 41.6507 134.095 41.8187 134.226 41.968C134.375 42.0987 134.543 42.164 134.73 42.164H147.526V45.188H134.646ZM134.03 35.752H144.474V32.672C144.474 32.4853 144.409 32.3267 144.278 32.196C144.147 32.0467 143.989 31.972 143.802 31.972H134.73C134.543 31.972 134.375 32.0467 134.226 32.196C134.095 32.3267 134.03 32.4853 134.03 32.672V35.752ZM153.459 45.188C152.787 45.188 152.181 45.02 151.639 44.684C151.098 44.348 150.659 43.9093 150.323 43.368C149.987 42.8267 149.819 42.22 149.819 41.548V23.628H152.843V41.464C152.843 41.6507 152.909 41.8187 153.039 41.968C153.189 42.0987 153.357 42.164 153.543 42.164H156.483V45.188H153.459Z",
    fill: "#FDE1B9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 25,
    r: 8,
    fill: "#FFEEB5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30.5,
    r: 30,
    stroke: "#FFEEB5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.6464,
    y1: 63.6464,
    x2: 75.6464,
    y2: 8.64645,
    stroke: "#FFF9B5"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelTitle);
export default __webpack_public_path__ + "static/media/fuel-title.13c320215df9d81844cfc2bb9a44dc5b.svg";
export { ForwardRef as ReactComponent };